import request from '@/utils/server'
export function getDeviceList(query) {
    return request({
      url: '/device/getDeviceList',
      method: 'get',
      params: query
    })
  }
// 新增
export function addDevice(data) {
  return request({
    url: '/device/add',
    method: 'POST',
    data: data
  })
}
//   删除设备
  export function delDevice(data) {
    return request({
      url: '/device/delDevice',
       method: 'POST',
      data: data
    })
  }
//   删除模版
  export function delModel(data) {
    return request({
      url: '/device/delModel',
       method: 'POST',
      data: data
    })
  }
  
  
  // 修改
  export function edit(data) {
    return request({
      url: '/device/edit',
      method: 'POST',
      data: data
    })
  }
  

  // 获取设备类型
  export function getDeviceTypeList(query) {
    return request({
      url: '/device/getDeviceTypeList',
      method: 'get',
      params: query
    })
  }
  // 新增
    export function addDeviceType(data) {
    return request({
      url: '/device/addDeviceType',
      method: 'POST',
      data: data
    })
  }
  // 删除
      export function delDeviceType(data) {
    return request({
      url: '/device/delDeviceType',
      method: 'POST',
      data: data
    })
  }
  // 获取所有设备模版
       export function getDeviceModeList(query) {
    return request({
      url: '/device/getDeviceModelList',
      method: 'GET',
      params: query
    })
  }
  // 获取设备大类
      export function getDeviceCategoryList(query) {
    return request({
      url: '/device/getDeviceCategoryList',
      method: 'GET',
      params: query
    })
  }
    // 新增设备模版
      export function addModel(data) {
    return request({
      url: '/device/addModel',
      method: 'POST',
      data: data
    })
  }
  // 新增设备大类
       export function addDeviceCategory(data) {
    return request({
      url: '/device/addDeviceCategory',
      method: 'POST',
      data: data
    })
  }
  // 删除设备大类

       export function delDeviceCategory(data) {
    return request({
      url: '/device/delDeviceCategory',
      method: 'POST',
      data: data
    })
  }